import React, { useEffect } from "react";
import NeedAppUpdateComponent from "./NeedAppUpdate.component";
import { isInApp, callAppStore, getIsIos } from "helpers/InApp.helper";
const NeedAppUpdateContainer = () => {

    useEffect(() => {
        if (isInApp()) {
            moveToAppStore();
        } else {
            window.location.href = "/";
        }
    }, []);

    const moveToAppStore = async () => {
        if (isInApp()) {
            const isIos = await getIsIos();
            await callAppStore(isIos);
        }
    }

    return <NeedAppUpdateComponent moveToAppStore={moveToAppStore} />;
};

export default NeedAppUpdateContainer;